<template>
  <div class="content">
    <h1>Sign up</h1>
    <p>In progress, you found us very early, no one should have found this yet.</p>
    <form @submit.prevent="submitInterest" class="mailing-list-form">
      <div class="form-group">
        <label for="email">Your Email:</label>
        <input type="email" v-model="email" id="email" required />
      </div>

      <div class="form-group">
        <label for="userType">I'm a:</label>
        <select v-model="userType" id="userType">
          <option value="customer">Hungry Customer</option>
          <option value="vendor">Restaurant / Vendor</option>
        </select>
      </div>

      <button type="submit">Notify Me</button>
    </form>

    <p class="vendor-link">
      Are you a vendor? you can <router-link to="/vendor-signup">Apply here</router-link>
    </p>

  </div>

</template>
<script>
export default {
  data() {
    return {
      email: "",
      userType: "customer",
    };
  },
  methods: {
    async submitInterest() {
      try {
        const response = await fetch("/publicmailinglist/create", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: this.email,
            type: this.userType,
          }),
        });

        if (!response.ok) throw new Error("Failed to submit");

        alert("Thanks! We'll be in touch soon.");
        this.email = "";
      } catch (err) {
        console.error(err);
        alert("There was a problem. Try again later.");
      }
    },
  },
};
</script>
<style>
  .mailing-list-form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    max-width: 600px;
    margin: 0 auto;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .mailing-list-form input,
  .mailing-list-form select {
    padding: 10px;
    border-radius: 5px;
    border: none;
    font-size: 16px;
  }

  .mailing-list-form button {
    padding: 12px;
    background-color: #1989a3;
    color: white;
    font-weight: bold;
    font-size: 16px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.3s ease;
  }

    .mailing-list-form button:hover {
      background-color: #156b80;
    }
  .vendor-link {
    text-align: center;
    margin-top: 30px;
    font-weight: bold;
  }
</style>

